import { useApp } from '../../context/AppContext';

export function Toast() {
  const { toast, undoState, handleUndo } = useApp();

  if (!toast && !undoState) return null;

  return (
    <>
      {/* Regular Toast */}
      {toast && !undoState && (
        <div
          role="alert"
          aria-live="polite"
          style={{
            position: "fixed",
            top: "1rem",
            left: "50%",
            transform: "translateX(-50%)",
            background: "#16a34a",
            color: "#fff",
            padding: "0.55rem 1.1rem",
            borderRadius: "99px",
            fontSize: "0.82rem",
            fontWeight: 600,
            zIndex: 9999,
            boxShadow: "0 4px 20px rgba(22,163,74,0.5)",
            animation: "fadeIn 0.25s ease",
            whiteSpace: "nowrap",
          }}
        >
          {toast.emoji} {toast.message}
        </div>
      )}

      {/* Undo Toast */}
      {undoState && (
        <div
          role="status"
          aria-live="polite"
          style={{
            position: "fixed",
            top: "1rem",
            left: "50%",
            transform: "translateX(-50%)",
            background: "#1c2b1e",
            border: "1px solid rgba(74,222,128,0.3)",
            color: "#e8f5e9",
            padding: "0.5rem 0.5rem 0.5rem 1rem",
            borderRadius: "99px",
            fontSize: "0.82rem",
            fontWeight: 500,
            zIndex: 9999,
            boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
            animation: "fadeIn 0.25s ease",
            display: "flex",
            alignItems: "center",
            gap: "0.6rem",
            whiteSpace: "nowrap",
          }}
        >
          <span>
            {undoState.wasCommitting ? "✅" : "↩"}{" "}
            {undoState.wasCommitting 
              ? `Committed: "${undoState.title}"` 
              : `Unmarked: "${undoState.title}"`}
          </span>
          <button
            onClick={handleUndo}
            aria-label="Undo this action"
            style={{
              background: "rgba(74,222,128,0.15)",
              border: "1px solid rgba(74,222,128,0.3)",
              color: "#4ade80",
              padding: "0.28rem 0.7rem",
              borderRadius: "99px",
              fontSize: "0.75rem",
              cursor: "pointer",
            }}
          >
            Undo
          </button>
        </div>
      )}
    </>
  );
}
